import React, { useState } from 'react';
import '../scss/GeneralServicesModal.scss';
import { VSCategoriesData } from "../data/vs";
import { PlusOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Row, Col, Modal, Result, Form, Input, DatePicker, Button, Divider, Upload, Select, message, InputNumber } from "antd";
import dayjs from "dayjs";
import OrderService from '../utils/api/orders';
import ChatService from '../utils/api/chat';

const { Option } = Select;

export default function GeneralServices({ onOrderCreated, onCancel }) {
	const user = JSON.parse(localStorage.getItem('user'))
	const userFcm = localStorage.getItem('fcm')

	const categories = VSCategoriesData

	const [loading, setLoading] = useState(false);
	const [services, setServices] = useState([{ title: '', description: '', file: null, fileName: '', quantity: 1 }]);
	const [formValue, setFormValue] = useState({
		title: "",
		time: "",
	});
	const [resultModal, setResultModal] = useState({
		open: false,
		type: '',
		title: '',
		description: '',
		req_id: '',
	});

	function isFormIncomplete() {
		if (!formValue.title || !formValue.time) { return true; }

		for (let service of services) {
			if (!service.title || !service.description || !service.cat || !service.quantity) { return true; }
		}

		return false;
	}

	const onChange = (index, targetInput) => {
		const updatedServices = [...services];
		updatedServices[index][targetInput.target.name] = targetInput.target.value;
		setServices(updatedServices);
	};

	const onQuantityChange = (index, value) => {
		const updatedServices = [...services];
		updatedServices[index].quantity = value || 1;
		setServices(updatedServices);
	};

	const onDateChange = (date, dateString) => {
		if (dayjs(date).isBefore(dayjs(), "day") || dayjs(date).isSame(dayjs(), "day")) {
			message.error("No puedes seleccionar la fecha actual o una pasada.");
			setFormValue((state) => ({ ...state, time: "" }));
		} else {
			setFormValue((state) => ({ ...state, time: dateString }));
		}
	};

	const disabledDate = (current) => {
		return current && (current.isBefore(dayjs(), "day") || current.isSame(dayjs(), "day"));
	};

	const getBase64 = (file, callback) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => callback(reader.result);
	};

	const handleFileChange = (index, file) => {
		getBase64(file, (base64) => {
			const updatedServices = [...services];
			updatedServices[index].file = base64;
			updatedServices[index].fileName = file.name;
			setServices(updatedServices);
		});
	};

	const removeFile = (index) => {
		const updatedServices = [...services];
		updatedServices[index].file = null;
		updatedServices[index].fileName = '';
		setServices(updatedServices);
	};

	const addService = () => {
		setServices([...services, { title: "", description: "", file: null, fileName: "", quantity: 1, cat: null }]);
	};

	const removeService = (index) => {
		if (services.length > 1) {
			const updatedServices = services.filter((_, i) => i !== index);
			setServices(updatedServices);
		}
	};

	const onFinish = () => {
		setLoading(true);

		const servicesPayload = services.map(s => ({
			title: s.title,
			description: s.description,
			cat: s.cat,
			quantity: s.quantity,
			file: s.file || "",
			fileName: s.fileName || ""
		}));

		let order = {
			client_id: user.id,
			client_name: user.name,
			client_email: user.email,
			client_bussiness: user.bussiness,
			client_fcm: userFcm,
			title: formValue.title,
			client_due_date: formValue.time,
			services: servicesPayload,
		};

		OrderService.NewOrder(order)
			.then(response => {
				if (response.data.success === true) {
					const order_id = response.data.order_id;

					const chatData = {
						clientId: user.id,
						services: servicesPayload.map(s => ({ category: s.cat }))
					};

					ChatService.NewOrder(order_id, chatData)
						.then(() => {
							setResultModal({
								open: true,
								type: 'success',
								title: '¡Solicitud enviada con éxito!',
								description: 'Tu número de orden es: ' + order_id + ', podrás ver tu pedido en el apartado de ORDENES.',
								req_id: order_id,
							});

							setFormValue({ title: "", time: "" });
							setServices([{ title: '', description: '', file: null, fileName: '', quantity: 1 }]);
							setLoading(false);
						})
						.catch(() => {
							setResultModal({
								open: true,
								type: 'error',
								description: 'No se pudieron crear los chats. Intenta nuevamente.',
								title: 'Error al crear los chats',
								req_id: order_id,
							});
							setLoading(false);
						});

				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setResultModal({
					open: true,
					type: 'error',
					description: 'Revisa tus datos e inténtalo de nuevo',
					title: 'Algo salió mal',
				});
				setLoading(false);
			});
	};

	const handleResultModalClose = () => {
		setResultModal({ ...resultModal, open: false });
		if (resultModal.type === 'success' && onOrderCreated) {
			onOrderCreated(resultModal.req_id);
		}
	};

	return (
		<>
			<div className="general-services-modal-content">
				<div className="modal-header">
					<h2 className="modal-title">Nueva Orden de Compra</h2>
					<p className="modal-subtitle">Complete la información requerida para crear una nueva orden</p>
				</div>

				<div className="modal-content">
					<div className="form-section">
						<Row gutter={[16, 16]}>
							<Col xs={24}>
								<Form.Item label="Título de la orden">
									<Input
										onChange={(e) => setFormValue((state) => ({ ...state, title: e.target.value }))}
										placeholder="Ingrese el título de la orden"
										size="large"
										value={formValue.title}
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={[16, 16]}>
							<Col xs={24} md={18}>
								<Form.Item label="¿Cuándo espera recibir el servicio?">
									<DatePicker
										style={{ width: "100%" }}
										placeholder="Seleccionar fecha"
										onChange={onDateChange}
										disabledDate={disabledDate}
										size="large"
										value={formValue.time ? dayjs(formValue.time) : null}
									/>
								</Form.Item>
							</Col>
						</Row>
					</div>

					<Divider>Servicios</Divider>

					<div className="services-section">
						{services.map((service, index) => (
							<div key={index} className="service-item">
								<div className="service-header">
									<h4 className="service-title">Servicio {index + 1}</h4>
									<div className="service-actions">
										{index !== 0 && (
											<Button
												shape="circle"
												type="danger"
												icon={<DeleteOutlined />}
												onClick={() => removeService(index)}
												size="small"
											/>
										)}
									</div>
								</div>

								<div className="service-content">
									<Row gutter={[16, 16]}>
										<Col xs={24}>
											<Form.Item label="Título del servicio">
												<Input
													name="title"
													value={service.title}
													onChange={(e) => onChange(index, e)}
													placeholder="Ingrese el título del servicio"
												/>
											</Form.Item>
										</Col>

										<Col xs={24}>
											<Form.Item label="Categoría">
												<Select
													allowClear
													onChange={(value) => {
														const updatedServices = [...services];
														updatedServices[index].cat = value;
														setServices(updatedServices);
													}}
													value={service.cat}
													placeholder="Seleccionar categoría"
													style={{ width: '100%' }}
												>
													{categories.map((category, idx) => (
														<Option key={idx} value={category.key}>
															{category.name}
														</Option>
													))}
												</Select>
											</Form.Item>
										</Col>

										<Col xs={24}>
											<Form.Item label="Descripción">
												<Input.TextArea
													name="description"
													value={service.description}
													onChange={(e) => onChange(index, e)}
													placeholder="Describa los detalles del servicio"
													rows={3}
												/>
											</Form.Item>
										</Col>

										<Col xs={24} md={12}>
											<Form.Item label="Cantidad">
												<InputNumber
													min={1}
													value={service.quantity}
													onChange={(value) => onQuantityChange(index, value)}
													style={{ width: "100%" }}
													placeholder="Cantidad"
												/>
											</Form.Item>
										</Col>

										<Col xs={24}>
											<div className="upload-section">
												<Form.Item label="Archivo adjunto">
													<div className="upload-container">
														{!service.file ? (
															<Upload
																beforeUpload={(file) => {
																	handleFileChange(index, file);
																	return false;
																}}
																showUploadList={false}
															>
																<Button icon={<UploadOutlined />} className="upload-button">
																	Seleccionar archivo
																</Button>
															</Upload>
														) : (
															<div className="file-info">
																<span className="file-name">{service.fileName}</span>
																<Button type="link" onClick={() => removeFile(index)} className="remove-file">
																	Eliminar
																</Button>
															</div>
														)}
													</div>
												</Form.Item>
											</div>
										</Col>
									</Row>
								</div>
							</div>
						))}

						<Button type="dashed" icon={<PlusOutlined />} onClick={addService} className="add-service-button">
							Agregar servicio
						</Button>
					</div>
				</div>

				<div className="modal-footer">
					<Button onClick={onCancel} className="cancel-button" size="large" disabled={loading}>
						Cancelar
					</Button>
					<Button
						type="primary"
						onClick={onFinish}
						loading={loading}
						disabled={isFormIncomplete()}
						className="submit-button"
						size="large"
					>
						Subir y Finalizar
					</Button>
				</div>
			</div>

			<Modal
				title="Notificación de solicitud"
				open={resultModal.open}
				onCancel={handleResultModalClose}
				footer={[
					<Button key="submit" type="primary" onClick={handleResultModalClose}>
						Aceptar
					</Button>,
				]}
				className="result-modal"
				width={400}
				destroyOnClose
			>
				<Result
					title={resultModal.title}
					status={resultModal.type}
					subTitle={resultModal.description}
				/>
			</Modal>
		</>
	);
}